import FW from '../fw/fw';
import Env from '../fw/env';
import Logger from '../fw/logger';
import VttJS from '../accessibility/vtt-js';


export default class ListHelpers {

  constructor() {}

  static initialListParsing(item0) {
    this.src = item0.src;
    this.seekBarThumbnailsLoc = item0.seekBarThumbnailsLoc;
    if (FW.isValidCCFiles(item0.ccFiles)) {
      if (Env.isIos[0]) {
        this.ccFiles = item0.ccFiles;
        this.hasExternalCCFiles = true;
      } else {
        this.rmpVttJS = new VttJS(this, item0.ccFiles);
      }
    }
    if (this.ads) {
      this.adTagUrl = item0.adTagUrl;
      if (item0.adTagUrl === '') {
        this.emptyInitAdTagUrl = true;
      }
      if (item0.adTagWaterfall) {
        this.adTagWaterfall = [...item0.adTagWaterfall];
      }
    }
    if (item0.shakaDrm) {
      this.shakaDrm = item0.shakaDrm;
    }
    if (item0.shakaRequestConfiguration) {
      this.shakaRequestConfiguration = item0.shakaRequestConfiguration;
    }
    if (item0.chaptersLoc) {
      this.chaptersLoc = item0.chaptersLoc;
    }
    if (item0.logo) {
      this.logo = item0.logo;
    }
    if (item0.sharingUrl) {
      this.sharingUrl = item0.sharingUrl;
    }
    if (item0.sharingCode) {
      this.sharingCode = item0.sharingCode;
    }
    item0.contentMetadata.noFilter = true;
    this.contentMetadataConfiguration = item0.contentMetadata;
    if (this.enableGAVideoTracking) {
      this.gaEventParametersConfiguration = { video_title: this.contentMetadata.title };
    }
    if (this.rmpMux && this.muxDataUseListData) {
      this.muxDataSettings.data.video_title = this.contentMetadata.title;
    }
    if (!FW.isEmptyObject(this.bitmovinAnalyticsConfig)) {
      const newAnalyticsData = {};
      newAnalyticsData.key = this.bitmovinAnalyticsConfig.key;
      newAnalyticsData.title = this.contentMetadata.title;
      newAnalyticsData.videoId = this.contentMetadata.id || FW.generateUuid();
      this.setBitmovinAnalytics(newAnalyticsData);
    }
  }

  static listParsing(newItem) {
    if (this.ads) {
      if (typeof newItem.adTagUrl === 'string' && newItem.adTagUrl !== '') {
        this.adTagUrl = newItem.adTagUrl;
        if (newItem.adTagWaterfall) {
          this.adTagWaterfall = [...newItem.adTagWaterfall];
        } else {
          this.adTagWaterfall = [];
        }
      } else {
        this.adTagUrl = null;
      }
    }
    if (this.rmpCCManagement) {
      this.rmpCCManagement.destroy();
    }
    if (FW.isValidCCFiles(newItem.ccFiles)) {
      this.captionsList = newItem.ccFiles;
    }
    newItem.contentMetadata.noFilter = true;
    this.contentMetadataConfiguration = newItem.contentMetadata;
    if (this.enableGAVideoTracking) {
      this.gaEventParametersConfiguration = { video_title: newItem.contentMetadata.title };
    }
    if (this.rmpMux && this.muxDataUseListData) {
      this.muxDataSettings.data.video_title = newItem.contentMetadata.title;
      window.mux.emit('#' + this.id + ' .rmp-video', 'videochange', {
        video_title: this.muxDataSettings.data.video_title
      });
    }
    if (!FW.isEmptyObject(this.bitmovinAnalyticsConfig)) {
      const newAnalyticsData = {};
      newAnalyticsData.key = this.bitmovinAnalyticsConfig.key;
      newAnalyticsData.title = newItem.contentMetadata.title;
      newAnalyticsData.videoId = newItem.contentMetadata.id || FW.generateUuid();
      this.setBitmovinAnalytics(newAnalyticsData);
    }
  }

  static filterList(inputPlaylist) {
    Logger.print('info', 'filter input JSON list now');
    const playlist = inputPlaylist;
    const indexToRemove = [];
    let sourceType;
    for (let i = 0, len = playlist.length; i < len; i++) {
      // filter sources
      if (playlist[i].src.hls) {
        sourceType = 'hls';
      } else if (playlist[i].src.dash) {
        sourceType = 'dash';
      } else if (playlist[i].src.mp4 && playlist[i].src.mp4[0]) {
        sourceType = 'mp4';
      } else if (playlist[i].src.webm && playlist[i].src.webm[0]) {
        sourceType = 'webm';
      } else if (playlist[i].src.m4a) {
        sourceType = 'm4a';
      } else if (playlist[i].src.mp3) {
        sourceType = 'mp3';
      } else if (playlist[i].src.ogg) {
        sourceType = 'ogg';
      } else {
        indexToRemove.push(i);
        continue;
      }
      const keys = [
        'contentMetadata',
        'adTagUrl',
        'src',
        'seekBarThumbnailsLoc',
        'ccFiles',
        'shakaDrm',
        'shakaRequestConfiguration'
      ];
      for (let j = 0, len = keys.length; j < len; j++) {
        const currentKey = keys[j];
        if (currentKey === 'contentMetadata') {
          playlist[i][currentKey] = FW.filterContentMetadata(playlist[i][currentKey]);
          continue;
        } else if (currentKey === 'adTagUrl' || currentKey === 'related' || currentKey === 'seekBarThumbnailsLoc' || currentKey === 'playlistLoc' || currentKey === 'sharingUrl' || currentKey === 'sharingCode') {
          if (typeof playlist[i][currentKey] !== 'string') {
            playlist[i][currentKey] = '';
            continue;
          }
        } else if (currentKey === 'src') {
          if (typeof playlist[i][currentKey][sourceType] !== 'string' &&
            !Array.isArray(playlist[i][currentKey][sourceType])) {
            indexToRemove.push(i);
            continue;
          }
        } else if (currentKey === 'adTagWaterfall') {
          if (!Array.isArray(playlist[i][currentKey]) || typeof playlist[i][currentKey][0] !== 'string' ||
            playlist[i][currentKey][0] === '') {
            delete playlist[i][currentKey];
            continue;
          }
        } else if (currentKey === 'ccFiles') {
          if (!FW.isValidCCFiles(playlist[i][currentKey])) {
            delete playlist[i][currentKey];
            continue;
          }
        } else if (currentKey === 'shakaDrm') {
          if (typeof playlist[i][currentKey] !== 'object' || typeof playlist[i][currentKey].servers !== 'object') {
            delete playlist[i][currentKey];
            continue;
          }
        } else if (currentKey === 'shakaRequestConfiguration' || currentKey === 'logo') {
          if (typeof playlist[i][currentKey] !== 'object') {
            delete playlist[i][currentKey];
            continue;
          }
        }
      }
    }
    if (indexToRemove.length > 0) {
      for (let i = indexToRemove.length - 1; i >= 0; i--) {
        playlist.splice(indexToRemove[i], 1);
      }
    }
    return playlist;
  }

}
